import React from "react";

interface SkimmerProps {
  className?: string;
  width?: string;
  height?: string;
  type?: "circle" | "rectangle";
}

const Skimmer: React.FC<SkimmerProps> = ({
  className,
  width,
  height,
  type,
}) => {
  return (
    <div
      className={`relative ${className ?? ""} ${width ?? "w-full"} ${
        height ?? "h-4"
      } ${
        type === "circle" ? "rounded-full" : "rounded"
      } mt-1 overflow-hidden bg-gray-200`}
    >
      <div className="absolute inset-0 bg-gray-300  w-full h-full ">
        <div className="absolute inset-0 bg-lightGray w-full h-full animate-shimmer"></div>
      </div>
    </div>
  );
};

export default Skimmer;
